import { Link } from "react-router-dom";
import { ArrowLeft, Database, LinkSimple } from "@phosphor-icons/react";
import { useContent } from "@/contexts/ContentContext";
import Footer from "@/components/Footer";
import Navbar from "@/components/Navbar";

export default function ApiDocsPage() {
  const { content, loading } = useContent();
  const docs = content?.api_docs || {};
  const apis = Array.isArray(docs.apis) ? docs.apis : [];

  return (
    <div className="min-h-screen bg-stone-50" data-testid="api-docs-page">
      <Navbar />
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-20 lg:py-28">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-stone-500 hover:text-emerald-700 mb-8" data-testid="apidocs-back-link">
          <ArrowLeft size={16} weight="bold" /> Back to home
        </Link>

        <header className="mb-12">
          <p className="text-xs tracking-[0.25em] uppercase font-semibold text-emerald-700 mb-3 font-body">
            Developers
          </p>
          <h1 className="font-heading text-3xl sm:text-4xl tracking-tight font-medium text-stone-900 mb-4" data-testid="api-docs-title">
            {docs.title || "API & Data Dictionary"}
          </h1>
          <p className="font-body text-base text-stone-500 max-w-2xl leading-relaxed" data-testid="api-docs-description">
            {docs.description || ""}
          </p>
        </header>

        {loading ? (
          <div className="h-48 animate-pulse bg-stone-200 rounded-2xl" />
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="api-list">
            {apis.map((api, idx) => (
              <article
                key={`${api.name}-${idx}`}
                className="bg-white border border-stone-200 rounded-3xl p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
                data-testid={`api-card-${idx}`}
              >
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 rounded-2xl bg-emerald-50 flex items-center justify-center flex-shrink-0">
                    <Database size={22} weight="duotone" className="text-emerald-700" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <h3 className="font-heading text-lg font-semibold text-stone-900 truncate">
                        {api.name}
                      </h3>
                      {api.category && (
                        <span className="text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full bg-stone-100 text-stone-600 font-medium">
                          {api.category}
                        </span>
                      )}
                    </div>
                    <p className="font-body text-sm text-stone-500 leading-relaxed mb-3">
                      {api.description}
                    </p>
                    {api.base_url && (
                      <div className="flex items-center gap-1.5 text-xs text-stone-400 font-mono break-all">
                        <LinkSimple size={12} />
                        <span>{api.base_url}</span>
                      </div>
                    )}
                    {api.auth && (
                      <p className="text-[11px] text-stone-400 mt-2">
                        Auth: <span className="text-stone-600">{api.auth}</span>
                      </p>
                    )}
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
